import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { LayoutList, Loader2 } from "lucide-react";
import { http, errMsg } from "../../lib/api";

export const StdInfo = () => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => http.get("/kits-bulk/standardize-info").then((x) => setD(x.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  const running = d?.status === "running" && !d?.stalled;
  useEffect(() => {
    if (d?.status !== "running") return undefined;
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, [d?.status, load]);
  const go = async () => {
    setBusy(true);
    try { const r = await http.post("/kits-bulk/standardize-info"); toast.message(`Completing the information boxes on ${r.data.kits} kit(s) — you can leave this page`); await load(); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <section data-testid="std-info-panel" className="mb-6 flex flex-wrap items-center gap-3 rounded-lg border border-stone-200 bg-white p-4">
      <LayoutList size={18} className="text-[#9A7B2C]" />
      <b className="text-[#2B2A26]">Information boxes</b>
      <span data-testid="std-info-status" className="text-sm text-stone-500">
        {d?.stalled ? `Paused at kit ${Math.min((d.done || 0) + 1, d.total || 1)} of ${d.total || "?"} — it will pick up again shortly, or tap Restart`
          : running ? `Completing kit ${Math.min((d.done || 0) + 1, d.total)} of ${d.total}${d.current ? ` · ${d.current}` : ""}…`
          : d?.status === "done" ? `Last run finished · ${d.total} kit(s) checked (researched and Founder's)` : "Give every venue the same information-box lines as your uploaded guides (web-verified, no prices)"}
      </span>
      {running ? <Loader2 size={15} className="ml-auto animate-spin text-[#9A7B2C]" /> : (
        <button data-testid="std-info-btn" disabled={busy} onClick={go} className="ml-auto inline-flex items-center gap-1.5 rounded-sm bg-[#2B2A26] px-3 py-1.5 text-xs font-bold text-white hover:bg-black transition-colors disabled:opacity-50">
          {busy && <Loader2 size={12} className="animate-spin" />} {d?.stalled ? "Restart" : "Complete information boxes"}
        </button>
      )}
    </section>
  );
};
